export enum SocialMediaErrorReason {
  UserDenied = "user_denied",
}

export enum SocialMediaPlatformCode {
  Instagram = "Instagram",
}

export enum SocialMediaConnectionStatus {
  Connected = "Connected",
  RequiresReauth = "RequiresReauth",
  NotConnected = "NotConnected",
}

export interface SocialMediaAccount {
  id: number;
  platformCode: SocialMediaPlatformCode;
  profileUrl: string;
  username: string;
  status: SocialMediaConnectionStatus;
  tokenExpiresAt: string;
}
